import React from "react";
import FigureCardContainer from "./figure-card-container";
const ChapterResult = ({
  enlargeFigure,
  figures,
  loadImageIndex,
  previousFiguresCount,
  title
}) => {
  if (figures.length > 0) {
    return (
      <li className="chapter-item">
        <h4>
          <span className="title">{title}</span>
          <span className="count">{`(${figures.length})`}</span>
        </h4>
        <ul className="chapter-figures">
          {figures.map((figure, index) => (
            <FigureCardContainer
              figure={figure}
              load={loadImageIndex > previousFiguresCount + index}
              onClick={() => {
                enlargeFigure(previousFiguresCount + index);
              }}
              key={figure.figureId}
            />
          ))}
        </ul>
      </li>
    );
  }
  return null;
};

export default ChapterResult;
